require('./components/appointment_info/appointment_info.ts');
require('./components/appointment_request_info/appointment_request_info.ts');
require('./components/carousel/carousel.ts');
require('./components/consider_todo_card/consider_todo_card.ts');
require('./components/custom_carousel/custom_carousel.ts');
require('./components/my_path_task_detail_child/my_path_task_detail_child_controller.ts');
require('./components/my_path_task_detail_header/my_path_task_detail_header.ts');
require('./components/my_todos_content/my_todos_content_controller.ts');
require('./components/path_checkbox/path_checkbox.ts');
require('./components/path_task_card/path_task_card.ts');
require('./components/tip_card/tip_card.ts');
require('./components/tip_details/tip_details_controller.ts');
require('./components/todo_details/todo_details.ts');
require('./components/todo_placement_test/todo_placement_test.ts');
require('./components/todo_refresh_button/todo_refresh_button.ts');
require('./components/todo_reminder_details/todo_reminder_details_controller.ts');
require('./components/todo_task_filter/todo_task_filter.ts');
require('./components/topic_container/topic_container.ts');
require('./components/topic_tile/topic_tile.ts');
require('./data/builders/path_item_builder.ts');
require('./data/builders/path_task_builder.ts');
require('./data/builders/path_topic_builder.ts');
require('./data/builders/placement_test_scores_builder.es.js');
require('./data/builders/topic_builder.js');
require('./data/commands/clear_path_datastores_command.ts');
require('./data/commands/get_adpative_path_changes_command.ts');
require('./data/commands/load_all_path_status_command.ts');
require('./data/commands/load_all_topics_command.ts');
require('./data/commands/load_appointment_details_command.es.js');
require('./data/commands/load_appointment_request_command.es.js');
require('./data/commands/load_path_item_command.es.js');
require('./data/commands/load_path_task_topics_command.ts');
require('./data/commands/load_path_tasks_command.ts');
require('./data/commands/load_placement_test_scores_command.js');
require('./data/commands/toggle_topic_opt_in_command.ts');
require('./data/commands/update_task_status_and_models_command.ts');
require('./data/commands/update_task_status_command.ts');
require('./data/commands/update_topic_opt_ins_command.ts');
require('./data/datasources/path_current_topic_datastore.ts');
require('./data/datasources/path_item_datastore.ts');
require('./data/datasources/path_overdue_task_datastore.ts');
require('./data/datasources/path_task_datastore.ts');
require('./data/datasources/path_topic_datastore.ts');
require('./data/decorators/path_item_decorator.ts');
require('./data/decorators/task_status_enum_decorator.ts');
require('./data/functions/path_task_formatter_fn.ts');
require('./data/functions/task_update_fn.ts');
require('./data/functions/time_formatter_fn.ts');
require('./data/interfaces/todo_interface.ts');
require('./data/models/path_task_visibility_status_model.js');
require('./data/queries/appointment_request_priority_feed_query.ts');
require('./data/queries/appointments_priority_feed_query.ts');
require('./data/queries/current_topics_query.ts');
require('./data/queries/data_ng_path_queries_module.ts');
require('./data/queries/events_priority_feed_query.ts');
require('./data/queries/mandatory_to_do_query.ts');
require('./data/queries/overdue_to_do_query.ts');
require('./data/queries/should_do_to_do_query.ts');
require('./data/queries/tip_to_do_query.ts');
require('./data/queries/to_do_priority_feed_query.ts');
require('./data/servants/to_do_builder_servant.ts');
require('./data/servants/to_do_filter_servant.ts');
require('./data/services/intake_question_service.ts');
require('./data/services/intake_status_service.ts');
require('./data/services/my_todos_content_service.ts');
require('./data/services/path_color_service.ts');
require('./data/services/path_task_update_service.ts');
require('./data/services/path_toggle_service.ts');
require('./data/services/task_detail_location_service.ts');
require('./data/services/todo_date_range_service.ts');
require('./data/services/todo_refresh_service.ts');
require('./data/types/path_presenter_detail_enum.ts');
require('./data/types/path_task_secondary_text.ts');
require('./data/types/placement_enum.ts');
require('./data/types/task_status_enum.ts');
require('./data/types/todo_filter_enum.ts');
require('./modals/path_auto_complete_modal/what_is_auto_complete_modal.ts');
require('./modals/path_modal_service.ts');
require('./modals/path_reminder_modal/reminder_date_picker_modal.ts');
require('./todo_interface.ts');



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-todos/src/core.ts